'use client'
import { Button } from '@payloadcms/ui'

export const StampaButton: React.FC = () => (
  <Button buttonStyle="primary" onClick={() => window.print()} size="medium">
    Stampa
  </Button>
)
